export default __webpack_public_path__ + "static/media/2507103.67bee331.jpg";